/*
Copyright 2021-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useTranslation } from "react-i18next";
import { type FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useClientState } from "../ClientContext";
import { ErrorPage, LoadingPage } from "../FullScreenView";
import { RegisteredView } from "./RegisteredView";
import { usePageTitle } from "../usePageTitle";

export const HomePage: FC = () => {
  const { t } = useTranslation();
  usePageTitle(t("common.home"));

  const clientState = useClientState();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect unauthenticated users to login page
    if (
      clientState &&
      clientState.state === "valid" &&
      !clientState.authenticated
    ) {
      void navigate("/login");
    }
  }, [clientState, navigate]);

  if (!clientState) {
    return <LoadingPage />;
  } else if (clientState.state === "error") {
    return <ErrorPage error={clientState.error} />;
  } else {
    return clientState.authenticated ? (
      <RegisteredView client={clientState.authenticated.client} />
    ) : (
      <LoadingPage />
    );
  }
};
